import { useState } from "react";
import { MenuItem } from "@mui/material";
import Text from "../../components/Text";
import Spinner from "../../components/Spinner";
import Dropdown from "../../components/Dropdown";
import FilterBar from "../../components/FilterBar";
import SearchBox from "../../components/SearchBox";
import PlantReportTable from "../../components/PlantReportTable";
import { Row, Col } from "../../components/Flexbox";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import { loadFromStorage, useSaveToStorage } from "../../utils";
import { usePlantReportNormalizer } from "../../containers/PlantReportNormalizer";
import { useMachineEfficiencyNormalizer } from "../../containers/MachineEfficiencyNormalizer";
import { useBonoDayNormalizer } from "../../containers/BonoDayNormalizer";
import { useMachineDayNormalizer } from "../../containers/MachineDayNormalizer";

const REPORTS = [
    {value: 'data', label: 'Data eficiencia', placeholder: 'Operador, nómina, OP o recurso'},
    {value: 'maquinas', label: 'Máquina eficiencia', placeholder: 'Máquina'},
    {value: 'bonoDia', label: 'Bono por día', placeholder: 'Nómina, nombre o máquina'},
    {value: 'maquinaDia', label: 'Máquina por día', placeholder: 'Máquina'},
];

const ReportesPlanta = () => {
    const {theme} = useTheme();

    const persisted = loadFromStorage('PLANT_REPORT_SELECTED') || {};
    const [report, setReport] = useState(REPORTS.some(r => r.value === persisted.report) ? persisted.report : REPORTS[0].value);

    useSaveToStorage('PLANT_REPORT_SELECTED', {report})

    const views = {
        data: usePlantReportNormalizer(report === 'data'),
        maquinas: useMachineEfficiencyNormalizer(report === 'maquinas'),
        bonoDia: useBonoDayNormalizer(report === 'bonoDia'),
        maquinaDia: useMachineDayNormalizer(report === 'maquinaDia'),
    };
    const {table, extraTables = [], loading, isFetching, fecha, minDate, maxDate, search, setFecha, setSearch, fetchData, exportCSV} = views[report];

    return (
        <Col style={{ width:'100%', flex:'none',alignItems:'flex-start', paddingLeft: 64, paddingRight:64, paddingTop:64}}>
            <Text size='21px' color={theme.Black}>Reportes de planta</Text>
            <FilterBar style={{width: '100%', maxHeight: '64px', gap: '26px', alignItems: 'center', marginTop: '32px', justifyContent: 'space-between'}}>
                <Row style={{flex: 1, justifyContent: 'flex-start', maxHeight: '36px', gap: 16}}>
                    <Dropdown theme={theme} value={report} onChange={setReport} style={{width: '220px', height: '36px'}}>
                        {REPORTS.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
                    </Dropdown>
                    {fecha && <input type="date" value={fecha} min={minDate} max={maxDate} onChange={(e) => e.target.value && setFecha(e.target.value)}
                        style={{height: 36, boxSizing: 'border-box', padding: '0 12px', borderRadius: 4, border: `0.5px solid ${theme.Ey}`, backgroundColor: 'transparent', color: theme.ONED, fontSize: 15}}/>}
                    <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} placeholder={REPORTS.find(r => r.value === report).placeholder} value={search} onChange={setSearch}></SearchBox>
                </Row>
                <Row style={{flex: 'none', justifyContent: 'end', maxHeight: '36px', gap: 16}}>
                    <Text onClick={() => !isFetching && fetchData()} style={{cursor:'pointer'}} color={theme.Magenta} size={15}>Actualizar</Text>
                    <Text onClick={exportCSV} style={{cursor:'pointer'}} color={theme.Magenta} size={15}>Exportar a Excel</Text>
                </Row>
            </FilterBar>
            <Col style={{width: '100%', height: '100%', alignItems: 'start', justifyContent: 'start', position: 'relative', marginTop: 32}}>
                <PlantReportTable table={table} theme={theme}/>
                {extraTables.filter(extra => extra.table.getRowModel().rows.length > 0).map((extra, i) => (
                    <div key={i} style={{width: '100%', marginTop: 24}}>
                        {extra.title && <Text size={15} color={theme.Black} style={{marginBottom: 8}}>{extra.title}</Text>}
                        <PlantReportTable table={extra.table} theme={theme} fit/>
                    </div>
                ))}
                {(loading || isFetching) &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Alfalfa}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
            </Col>
        </Col>
    )
}

export default ReportesPlanta;